import { v4 as uuid } from 'uuid';
import { DateTime } from 'luxon';

export interface IBankruptcyResponse {
  clear: boolean;
  id: string;
  created_at?: string;
}

export interface IBankruptcyData {
  clear: boolean;
  id: string;
  createdAt?: string;
}

export const createDefaultBankruptcyData = (): IBankruptcyData => ({
  clear: true,
  id: uuid(),
  createdAt: DateTime.local().toISO(),
});

export const convertBankruptcyResponseToBankruptcyData = (res: IBankruptcyResponse): IBankruptcyData => ({
  clear: res.clear,
  id: res.id,
  createdAt: res.created_at,
});

export const convertBankruptcyDataToBankruptcyResponse = (data: IBankruptcyData): IBankruptcyResponse => ({
  clear: data.clear,
  id: data.id,
  created_at: data.createdAt,
});
